import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal, Form, Checkbox, Input, Button } from 'semantic-ui-react';
// import { getSnapshot, applySnapshot, hasParent } from 'mobx-state-tree';

class MaterialForm extends Component {
  // initialSnapshot = null

  // constructor(props) {
  //   super(props)
  //   if (!props.model) return
  //   this.initialSnapshot = getSnapshot(props.model)
  // }

  render() {
    const { model } = this.props;
    if (!model) return null
    const costPer = {
      each: '$ each',
      metre: '$ per metre',
      sheet: '$ per sheet'
    }
    const handleChangeDescription = event => model.setDescription(event.target.value)
    const handleChangeSupplier = event => model.setSupplier(event.target.value)
    const handleChangeComment = event => model.setComment(event.target.value)
    const handleChangeUnits = event => model.setUnits(event.target.value)
    const toggleFixedLength = () => {
      if (model.stockLength) {
        model.setStockLength(null)
      } else {
        model.setStockLength(5.5)
      }
    }
    const handleChangeStockLength = event => {
      const parsedValue = parseFloat(event.target.value)
      if (!isNaN(parsedValue)) model.setStockLength(parsedValue)
    }
    const handleChangeSheetSizeX = event => {
      const parsedValue = parseFloat(event.target.value)
      if (!isNaN(parsedValue)) model.setSheetSizeX(parsedValue)
    }
    const handleChangeSheetSizeY = event => {
      const parsedValue = parseFloat(event.target.value)
      if (!isNaN(parsedValue)) model.setSheetSizeY(parsedValue)
    }
    const handleChangeUnitCost = event => {
      const parsedValue = parseFloat(event.target.value)
      if (!isNaN(parsedValue)) model.setUnitCost(parsedValue)
    }
    const selectAll = event => event.target.select()
    
    return (
      <Modal open={this.props.isOpen}>
        <Modal.Header content='Material' />
        <Modal.Content scrolling>
          <Form as='div'>
            <Form.Input width={8} label='Description' value={model.description} onChange={handleChangeDescription} autoFocus />
            <Form.Group>
              <Form.Field width={4}>
                <label>Units</label>
                <select value={model.units} onChange={handleChangeUnits}>
                  <option value='each'>each</option>
                  <option value='metre'>per metre</option>
                  <option value='sheet'>stock sheet</option>
                </select>
              </Form.Field>
              {model.units === 'metre' &&
                <Form.Field width={4}>
                  <label>Fixed length stock?</label>
                  <Checkbox label='Yes' checked={model.isFixedLength} onChange={toggleFixedLength} />
                </Form.Field>
              }
              {model.units === 'metre' && model.isFixedLength &&
                <Form.Field width={4}>
                  <label>Length of stock</label>
                  <Input 
                    type='number'
                    step='0.001'
                    value={model.stockLength || ''}
                    onChange={handleChangeStockLength}
                    fluid
                    label='m' 
                    labelPosition='right' 
                    onFocus={selectAll}
                  />
                </Form.Field>
              }
              {model.units === 'sheet' &&
                <Form.Field width={8}>
                  <label>Sheet size</label>
                  <Form.Group inline widths='equal'>
                    <Input 
                      type='number'
                      step='0.001'
                      max='99'
                      placeholder='Length'
                      value={model.sheetSizeX || ''}
                      onChange={handleChangeSheetSizeX}
                      label='m' 
                      labelPosition='right' 
                      onFocus={selectAll}
                    />
                    <Input 
                      type='number'
                      step='0.001'
                      max='99'
                      placeholder='Width'
                      value={model.sheetSizeY || ''}
                      onChange={handleChangeSheetSizeY}
                      label='m' 
                      labelPosition='right' 
                      onFocus={selectAll}
                    />
                  </Form.Group>
                </Form.Field>
              }
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <label>Cost</label>
                <Input 
                  type='number'
                  step='0.01'
                  value={model.unitCost}
                  onChange={handleChangeUnitCost}
                  label={costPer[model.units]} 
                  labelPosition='right' 
                  onFocus={selectAll}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Input width={6} label='Supplier' value={model.supplier} onChange={handleChangeSupplier} />
              <Form.Input width={6} label='Comment' value={model.comment} onChange={handleChangeComment} />
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button positive disabled={!model.isValid} onClick={this.handleSave} content='Save' />
          <Button type='button' color='orange' onClick={this.handleCancel} content='Cancel' />
        </Modal.Actions>
      </Modal>
    )
  }

  handleSave = () => {
    // const { model, store, onClose } = this.props
    // if (!hasParent(model)) {
    //   store.setCollectionItemFromSnapshot('materials', getSnapshot(model))
    // }
    // model.save()
    this.props.onSave()
    this.props.onClose()
  }

  handleCancel = () => {
    // applySnapshot(this.props.model, this.initialSnapshot)
    this.props.onClose()
  }
}

export default inject('store')(observer(MaterialForm));


// WEBPACK FOOTER //
// ./src/components/materials/MaterialForm.js